export const getApiBaseUrl = async (setter, token) => {
    const fetch1 = fetch(document.location.origin + '/config/baseUrl', {
        method: 'get'
    });

    const fetch2 = fetch(document.location.origin + '/config/altBaseUrl', {
        method: 'get'
    });

    const response1 = await fetch1;
    const response2 = await fetch2;

    const baseUrl = await response1.text();
    const altUrl = await response2.text();

    console.log("Base: " + baseUrl + "; alt: " + altUrl);

    if (baseUrl.startsWith("https://") && altUrl.startsWith("https://")) {
        var reachable1 = false;
        var reachable2 = false;

        try {
            reachable1 = await baseUrlIsReachable(baseUrl, token);
        } catch (err) {
            console.log("Error testing base URL: " + err);
        }
        try {
            reachable2 = await baseUrlIsReachable(altUrl, token);
        } catch (err) {
            console.log("Error testing alt URL: " + err);
        }

        console.log("1: " + reachable1 + "; 2: " + reachable2);

        if (reachable1) {
            console.log(baseUrl + " is reachable.");
            setter(baseUrl);
        } else if (reachable2) {
            console.log(altUrl + " is reachable.");
            setter(altUrl);
        } else {
            console.error("No API URL is reachable!");
        }
    } else if (baseUrl.startsWith("https://")) {
        console.warn("Only base URL found, no alternate");
        setter(baseUrl);
    } else if (altUrl.startsWith("https://")) {
        console.warn("Only alternate URL found");
        setter(altUrl);
    } else {
        console.warn("No URLS found, falling back on localhost");
        setter("http://localhost:8080");
    }
}

const baseUrlIsReachable = async (url, token) => {
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${token}`);

    const response = await fetch(url + '/ui/test', {
        method: 'get',
        headers: headers
    });
    if (response.ok) {
        console.log("Success reaching base URL " + url);
        return true;
    } else {
        console.error("Error determining base URL: " + url + "; error: " + response.status);
        return false;
    }
}

export const authenticatedRequest = (url, token, successCallback, errorCallback) => {
    const doFetch = (authToken) => {
        const headers = new Headers();
        headers.append("Authorization", `Bearer ${authToken}`);
        return fetch(url, { method: 'get', headers });
    };

    doFetch(token)
        .then(res => {
            if (res.ok) {
                return res.json().then(successCallback);
            }
            if (res.status === 401) {
                const freshUser = JSON.parse(sessionStorage.getItem("app:user"));
                if (freshUser && freshUser.access_token && freshUser.access_token !== token) {
                    return doFetch(freshUser.access_token).then(retryRes => {
                        if (retryRes.ok) {
                            return retryRes.json().then(successCallback);
                        }
                        errorCallback(retryRes);
                    });
                }
            }
            errorCallback(res);
        });
}